import { useContext, useEffect, useState } from 'react'
import { IconCheck, IconX } from '@tabler/icons-react'
import { Button, Group, Stack, Text } from '@mantine/core'
import { OfferFormDecisionContext } from '@shared/components/offers/offer-form-decision-context'
import { UUIDTypes } from 'uuid'

type OfferFormDecisionInputProps = {
  woolLotId: UUIDTypes
  index: number
}

export function OfferFormDecisionInput({ woolLotId, index }: OfferFormDecisionInputProps) {
  const [lotDecision, setLotDecision] = useState<boolean | undefined>(undefined)
  const { form, decisionCallback } = useContext(OfferFormDecisionContext)
  const errorFieldName = `decisions.${index}.accepted`

  useEffect(() => {
    if (lotDecision !== undefined) {
      decisionCallback(woolLotId, lotDecision)
    }
  }, [lotDecision])

  return (
    <Stack gap='xs'>
      <Group>
        <Button
          color='green.7'
          variant={lotDecision ? 'filled' : 'outline'}
          fw={600}
          leftSection={<IconCheck />}
          aria-label={
            lotDecision
              ? `Wool lot ${index + 1} offer accepted`
              : `Accept offer for wool lot ${index + 1}`
          }
          onClick={() => setLotDecision(true)}
        >
          Accept Offer
        </Button>

        <Button
          color='red'
          variant={lotDecision === false ? 'filled' : 'outline'}
          fw={600}
          leftSection={<IconX />}
          aria-label={
            lotDecision === false
              ? `Wool lot ${index + 1} offer declined`
              : `Decline offer for wool lot ${index + 1}`
          }
          onClick={() => setLotDecision(false)}
        >
          Decline Offer
        </Button>
      </Group>
      {form?.errors?.[errorFieldName] && (
        <Text size='xs' c='red' ta='center'>
          {form?.errors?.[errorFieldName]}
        </Text>
      )}
    </Stack>
  )
}
